import { InputField } from 'components/InputField';
import { LabelField } from "components/LabelField";
import React from 'react';
import { Col, Row } from 'react-bootstrap';

const StripeForm = ({formik,disabled}) => {
  return (
    <Row>
      <Col className="col-sm-6">
        <LabelField title="Stripe key" mandatory hint="Your Stripe secret API key, used on the server to process charges. Keep this private." />
        <InputField
          type="password"
          mandatory={true}
          {...{
            formik,
            title: 'none',
            formStyle: { marginBottom: 0 },
            name: 'stripe_key',
            placeholder: 'Stripe key',
            checkValidation: true,
          }}
          value={disabled ? "...................." : formik.values?.stripe?.stripe_key}
          handleChange={(e) => {
            formik.setFieldValue('stripe.stripe_key', e.target?.value);
          }}
          autoComplete="new-password"
        />
      </Col>
      <Col className="col-sm-6" >
        <LabelField title="Stripe publishable key" mandatory hint="Your Stripe public key, used in the browser to securely tokenize card details. Safe to expose, unlike the Stripe key." />
        <InputField
          type="password"
          mandatory={true}
          {...{
            formik,
            title: "none",
            formStyle: { marginBottom: 0 },
            name: "publicKey",
            placeholder: "Stripe publishable key",
            checkValidation: true,
          }}
          value={disabled ? "...................." : formik.values?.stripe?.publicKey}
          handleChange={(e) => {
            formik.setFieldValue('stripe.publicKey', e.target?.value);
          }}
          autoComplete="new-password"
        />
      </Col>
    </Row>
  )
}

export default StripeForm